module.exports = __webpack_public_path__ + "img/P37-zh.4eab6767.png";